//
//  I00RELGAZPUISSCalcul.js
//
//  Created by Sébastien Hecart on 2017-11-21 14:33:51 +0000.
//  Copyright © 2017 Sebastien Hecart. All rights reserved.
//

import { I00RELGAZPUISS_State } from '@batical/types/src'

import { cValue, puissanceChaudiere } from '../CommonFormula'

function I00RELGAZPUISS_docalcul(state: I00RELGAZPUISS_State) {
  //TODO CALCUL
  let res_C = cValue(state.in_pressionAtmospherique, state.in_pressionGaz, state.in_temperatureGaz)
  let res_puisanceChaudiere = puissanceChaudiere(state.in_debitCompteur, state.in_pci, res_C)
  state.invalidated = false
  return {
    ...state,
    res_puisanceChaudiere
  }
}

export default I00RELGAZPUISS_docalcul
